package de.katoonerie.content

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import de.katoonerie.contentful.ContentfulClient
import de.katoonerie.contentful.Homepage
import de.katoonerie.stylesheet.AppCssVariables.accentColor
import de.katoonerie.stylesheet.AppCssVariables.backgroundColor
import de.katoonerie.type.Result
import de.katoonerie.util.variable
import kotlinx.coroutines.launch
import org.jetbrains.compose.web.dom.Div

@Composable
fun Homepage(
    contentfulClient: ContentfulClient,
    preview: Boolean = false,
    content: @Composable Homepage.() -> Unit
) {
    val coroutineScope = rememberCoroutineScope()
    var result: Result<Homepage> by remember { mutableStateOf(Result.Pending) }

    if (result is Result.Pending) {
        coroutineScope.launch {
            result = contentfulClient.getHomepage(preview)
        }
    }

    when (val homepage = result) {
        is Result.Pending -> Loading()
        is Result.Error -> Error()
        is Result.Success<Homepage> -> Div(attrs = {
            classes("w-full", "h-full")
            style {
                variable(accentColor, homepage.value.colors.accent)
                variable(backgroundColor, homepage.value.colors.background)
            }
        }) {
            content(homepage.value)
        }
    }
}
